import { FieldWeb } from 'app/shared/model/item.model';

import { FormFieldColumn } from './form-field-column/form-field-column';
import { FormFieldColumnComponent } from './form-field-column/form-field-column.component';
import { FormFieldHeader } from './form-field-header/form-field-header';

export class FormField {
  id: string;
  kind: string;
  header: FormFieldHeader;
  expandable = false;
  grid: FormFieldColumn[][];

  constructor(item: FieldWeb, header: FormFieldHeader) {
    this.id = item._id;
    this.kind = item.kind;
    this.header = header;

    // the default behavior is to create a single generic column
    this.grid = [[new FormFieldColumn(item, FormFieldColumnComponent)]];
  }
}
